import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    allLSMAcceptanceReasons: [],
    LSMAcceptanceReasonDropDown: [],
    addModal: false
};

// fetch all LSM acceptance reasons
export const fetchAllLSMAcceptanceReasons = createAsyncThunk(
    'bmr/fetchAllLSMAcceptanceReasons',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/lsm_acceptance_reasons');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// add LSM acceptance reason
export const addLSMAcceptanceReason = createAsyncThunk(
    'bmr/addLSMAcceptanceReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.post('/lsm_acceptance_reasons/create', args);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllLSMAcceptanceReasons());
            return response.data;
        } catch (error) {
            notify.error(error || error.message);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// edit LSM acceptance reason
export const editLSMAcceptanceReason = createAsyncThunk(
    'bmr/editLSMAcceptanceReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { data, editId } = args;
            const response = await api.put(`/lsm_acceptance_reasons/update/${editId}`, data);
            notify.success(response.data.message);
            dispatch(disableAddModal());
            dispatch(fetchAllLSMAcceptanceReasons());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// delete LSM acceptance reason
export const deleteLSMAcceptanceReason = createAsyncThunk(
    'bmr/deleteLSMAcceptanceReason',
    async (args, { rejectWithValue, dispatch }) => {
        try {
            const { id } = args;
            const response = await api.delete(`/lsm_acceptance_reasons/${id}`);
            notify.success(response.data.message);
            dispatch(fetchAllLSMAcceptanceReasons());
            return response.data;
        } catch (error) {
            notify.error(error?.message || error);
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info get Esential patient for the portal 1
export const fetchLSMAcceptanceReasonDropDown = createAsyncThunk(
    'bmr/fetchLSMAcceptanceReasonDropDown',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`/lsm_acceptance_reasons/active/status`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const bmrLSMAcceptanceReasonsSlice = createSlice({
    name: 'bmrLSMAcceptanceReasons',
    initialState,
    reducers: {
        enableAddModal(state) {
            state.addModal = true;
        },
        disableAddModal(state) {
            state.addModal = false;
        },
    },
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(fetchAllLSMAcceptanceReasons.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllLSMAcceptanceReasons.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLSMAcceptanceReasons = action.payload.data;
            })
            .addCase(fetchAllLSMAcceptanceReasons.rejected, (state) => {
                state.isLoading = false;
            })
            // add
            .addCase(addLSMAcceptanceReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(addLSMAcceptanceReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(addLSMAcceptanceReason.rejected, (state) => {
                state.isLoading = false;
            })
            // edit
            .addCase(editLSMAcceptanceReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(editLSMAcceptanceReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(editLSMAcceptanceReason.rejected, (state) => {
                state.isLoading = false;
            })
            // delete
            .addCase(deleteLSMAcceptanceReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteLSMAcceptanceReason.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(deleteLSMAcceptanceReason.rejected, (state) => {
                state.isLoading = false;
            })
                // dropdown
                .addCase(fetchLSMAcceptanceReasonDropDown.pending, (state) => {
                    state.isLoading = true;
                })
                .addCase(fetchLSMAcceptanceReasonDropDown.fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.LSMAcceptanceReasonDropDown = action.payload.data.items?.map(op => { return { value: op?.id, label: op.name } })
                })
                .addCase(fetchLSMAcceptanceReasonDropDown.rejected, (state) => {
                    state.isLoading = false;
                });
    },
});

export const { disableAddModal, enableAddModal } = bmrLSMAcceptanceReasonsSlice.actions;

export const selectLSMAcceptanceReasonsLoading = (state) => state.bmrLSMAcceptanceReasons.isLoading;
export const selectLSMAcceptanceReasonsAll = (state) => state.bmrLSMAcceptanceReasons.allLSMAcceptanceReasons;
export const selectBmrAddLSMAcceptanceReasonModal = (state) => state.bmrLSMAcceptanceReasons.addModal;
export const selectBmrbmrLSMAcceptanceReasonsDropDown = (state) => state.bmrLSMAcceptanceReasons.LSMAcceptanceReasonDropDown;

export default bmrLSMAcceptanceReasonsSlice.reducer;
